import {
  Container,
  ContainerRow,
  FloatingButtons,
  HeaderIcon,
  Title,
} from './styled';
import { Column } from '@simplywallst/ui-core';
import CompanyIcon from './components/CompanyIcon';
import { BreadcrumbContainer } from '@/components/Header';
import Breadcrumb from '@/components/Breadcrumb';
import loadable from '@loadable/component';
import useUser from '@/hooks/useUser';
import { useUserAccess } from '@/hooks/useUserAccess';
import { MetaData } from './components/MetaData';
import { useSummary, useDownloadCSV } from '@/hooks/useCompany';
import { CoverImage } from './components/CoverImage';
import { useBreadcrumbs } from './hooks/useBreadcrumbs';
import { useTranslation } from '@/hooks/useTranslation';

const WatchlistHeaderActions = loadable(
  () => import('@/pages/CompanyReport/components/WatchlistHeaderActions'),
  { ssr: false }
);
interface Props {
  minHeight?: boolean;
  rounded?: boolean;
}
export const HEADER_BOTTOM = 'header-bottom';
const Header = ({ minHeight }: Props) => {
  const user = useUser();
  const { data: userAccess } = useUserAccess();
  const selected = useBreadcrumbs();
  const summary = useSummary();
  const downloadCSV = useDownloadCSV(
    summary.canonicalUrl,
    summary.status === 'success' ? summary.uniqueSymbol : undefined
  );
  const t = useTranslation();
  function handleFetchCompanyCsvReport() {
    downloadCSV?.mutate();
  }
  return (
    <>
      <Container data-cy-id="header-cover-image" minHeight={minHeight}>
        {summary.status === 'success' ? (
          <ContainerRow fillVoid>
            {summary.coverImage !== '' && summary.coverImage !== null ? (
              <CoverImage src={summary.coverImage} />
            ) : null}
            <Column column>
              <BreadcrumbContainer>
                <Breadcrumb
                  list={
                    selected.status === 'success' ? selected.breadcrumbs : []
                  }
                />
              </BreadcrumbContainer>
              <HeaderIcon>
                <CompanyIcon
                  //Key used to reset state on change of company
                  key={summary.companyId}
                  companyId={summary.companyId}
                />
              </HeaderIcon>
              <div style={{ position: 'relative' }}>
                <Title data-cy-id="company-header-title">
                  {summary.name + ' '}
                  <span>
                    {t('page.companyReport.header.companyTitle', {
                      uniqueSymbol: summary.uniqueSymbol,
                    })}
                  </span>
                </Title>
              </div>
            </Column>
            <Column>
              <FloatingButtons>
                <WatchlistHeaderActions
                  companyId={summary.companyId}
                  isUserLoggedIn={user.data.loggedIn}
                  canonicalUrl={summary.canonicalUrl}
                  uniqueSymbol={summary.uniqueSymbol}
                  tickerSymbol={summary.tickerSymbol}
                  canGetReportPdf={userAccess.canGetCompanyReportPdf}
                  canGetReportCsv={userAccess.canGetCompanyReportCsv}
                  canGetShareLink={userAccess.canDistributeCompanyReportPdf}
                  onFetchCompanyCsvReport={handleFetchCompanyCsvReport}
                />
              </FloatingButtons>
            </Column>
            <MetaData />
          </ContainerRow>
        ) : null}

        <span id={HEADER_BOTTOM}></span>
      </Container>
    </>
  );
};

Header.defaultProps = {
  minHeight: false,
};

export default Header;
